import { createBalanceStore } from './create-balance-store';

export const { useBalanceStore, useHasEnoughMinutesToDub, useUploadGate } = createBalanceStore();
